import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AvailableOn from '../AvailableOn/AvailableOn';
import './TermConditions.css';   // reuse the same policies-section styles

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Kuku Namkeen | Privacy Policy</title>
                <meta
                    name="description"
                    content="Read the Privacy Policy of Kuku Namkeen to understand how we collect, use and protect your personal information."
                />
                <link rel="canonical" href="https://kukunamkeen.in/privacy-policy" />
            </Helmet>

            {/* Page Header Banner */}
            <section className="term-header-title">
                <div className="max-w-6xl mx-auto px-4">
                    <h1>PRIVACY POLICY</h1>
                </div>
            </section>
            <img
                src="/Image/border-bottom-title.png"
                className="w-full header-title-image"
                alt=""
            />

            {/* Privacy Policy Content */}
            <section className="policies-section">
                <div className="max-w-6xl mx-auto px-4 lg:px-8">

                    {/* Intro */}
                    <div className="block-margin">
                        <p>
                            <strong>Policy Updated: February 20, 2023</strong>
                        </p>
                        <p>
                            Kuku Namkeen understands the importance of protecting the privacy of its customers. Our Privacy
                            Policy has been updated to give you a better understanding of how we treat your data and to call
                            your attention to new features. Please review this Privacy Policy and the manners in which the
                            information shall be utilized.
                        </p>
                        <p>
                            The personal information so collected is used to market, study, analysis, process and improve the
                            services offered by us and our subsidiaries/associates and also to contact you with updates to the
                            web site or for other marketing and internal business analytical / review purposes.
                        </p>
                    </div>

                    {/* Consent */}
                    <div className="block-margin">
                        <h3 className="heading-title uppercase">Consent</h3>
                        <p>
                            By using this site, you agree to the terms of this Privacy Policy. Whenever you submit information
                            via this site, you consent to the collection, use and disclosure of the information in accordance
                            with this Privacy Policy.
                        </p>
                    </div>

                    {/* Information Collected */}
                    <div className="block-margin">
                        <h3 className="heading-title uppercase">Information Collected</h3>
                        <p>
                            Kuku Namkeen does not mandatorily ask for your personal information. There are pages by which a user
                            can contact Kuku Namkeen and buy products but sharing personal information is entirely on the
                            discretion of the user and thus at sole risk of the user/customer.
                        </p>
                        <p>
                            We may encourage you to register your details with personal information for login account / guest
                            account purposes only as Kuku Namkeen does not ask for or store any financial information of any
                            party and sharing of personal information during registration process is to contact you for updates,
                            new products range and offerings which is at choice of the customer.
                        </p>
                        <p>
                            However, by providing personal information to us when you create or update your account and profile
                            (including guest profile), you are expressly and voluntarily accepting the terms and conditions of
                            Kuku Namkeen user agreement and freely accepting and agreeing to our processing of your personal
                            information in ways set out by this Privacy Policy or as amended from time to time.
                        </p>
                    </div>

                    {/* Use & Disclosure */}
                    <div className="block-margin">
                        <h3 className="heading-title uppercase">Use &amp; Disclosure</h3>
                        <p>
                            By using this site, you agree to the terms of this Privacy Policy. Whenever you submit information
                            via this site, you consent to the collection, use and disclosure of the information in accordance
                            with this Privacy Policy.
                        </p>
                        <p>
                            The information collected through this site helps us identify the type of web site content our
                            customers value most. We use this information to market and improve the web site and our services.
                            We also use this information to send you emailers / notifications for various purposes including but
                            not limited to information on new products, best sellers, order processing and to contact you by
                            other means for marketing and other purposes. Our policy is to not give, sell or otherwise
                            distribute the information collected through this site to third parties outside of Kuku Namkeen and
                            its subsidiaries/associates (unless required by law).
                        </p>
                    </div>

                    {/* Credit Card Details */}
                    <div className="block-margin">
                        <h3 className="heading-title uppercase">Credit Card Details</h3>
                        <p>Kuku Namkeen does not store any of your credit card details.</p>
                    </div>

                    {/* Information Protection */}
                    <div className="block-margin">
                        <h3 className="heading-title uppercase">Information Protection</h3>
                        <p>
                            By availing of the goods and services from our website, you understand that there is some risk
                            involved during transmitting to other vendor/bank websites for making necessary payment and all risk
                            attached thereon to the transaction is understood and acknowledged by you. Further, since each third
                            party vis-à-vis banks, vendor website, have their own privacy statements that can be viewed by
                            clicking on the corresponding links within each of the respective website.
                        </p>
                        <p>
                            Online merchants, payment gateways and others who participate in our services are encouraged to
                            participate in industry privacy initiatives and to take a responsible attitude towards consumer
                            privacy. However, since we do not have direct control over the policies or practices of
                            participating merchants and other third parties, we are not responsible for the privacy practices or
                            contents of those sites and breach of any 'sensitive' information causing any loss, damage to you
                            (direct or indirect) is solely at your risk and Kuku Namkeen shall not be party to such fraudulent
                            practices of any third-party vendor.
                        </p>
                        <p>
                            We recommend and encourage that you always review the privacy policies of merchants and other third
                            parties before you provide any personal information or complete any transaction with any third
                            parties.
                        </p>
                    </div>

                    {/* Duration of Information Retention */}
                    <div className="block-margin">
                        <h3 className="heading-title uppercase">Duration of Information Retention</h3>
                        <p>
                            Kuku Namkeen keep your information for as long as your account is active or as needed. However, we
                            may keep certain information even after you close your account if it is necessary to comply with our
                            legal obligations, meet regulatory requirements, resolve disputes, prevent fraud and abuse, or
                            enforce this agreement.
                        </p>
                    </div>

                    {/* Changes to Privacy Statement */}
                    <div className="block-margin">
                        <h3 className="heading-title uppercase">Changes to Privacy Statement</h3>
                        <p>
                            This privacy statement is in effect as of the date noted at the top of the statement. We may change
                            this privacy statement from time to time. If we do, we will post the revised version here and change
                            the "Effective Date" (the date it applies from) at the top of the statement. You should check here
                            regularly for the most up-to-date version of the statement.
                        </p>
                    </div>

                    {/* Contact Us */}
                    <div className="block-margin">
                        <h3 className="heading-title uppercase">Contact us Kuku Namkeen</h3>
                        <p>
                            Our corporate postal address is: Kuku Food Products, Shed no, A-4B, Hirji Mistry Rd, nr. Nana
                            udhyog vasahat, Jamnagar - 361 004. We can be reached via email at{' '}
                            <a href="mailto:kukunamkeen65@gmail.com" style={{ color: '#181a86' }}>
                                kukunamkeen65@gmail.com
                            </a>{' '}
                            or by phone at numbers found on the Contact us page. Our best endeavour shall be to support you
                            and resolve all issues in best of manner.
                        </p>
                        <p>
                            Additional resources on information privacy.<br />
                            Kuku Namkeen reserves the right to amend the Privacy Policy at any time with or without notice.
                            Please check back frequently in the event of changes. Your use of Kuku Namkeen constitutes your
                            agreement to this Privacy Policy.
                        </p>
                    </div>

                </div>
            </section>

            {/* Available On */}
            <AvailableOn />
        </>
    );
};

export default PrivacyPolicy;
